// Home page data with image requires
export function getHomeData() {
  return {
    hero: {
      heading: "Elevate Your Fitness.\nTransform Your Life.",
      description: "Transforming Lives Through Fitness Since 2009.",
      buttonText: "Talk To Us",
      whatsappLink: "https://api.whatsapp.com/send?phone=60123063136&text=Hello%20Studio%20V!%20I%27m%20interested%20to%20join%20your%20classes.%20"
    },

    services: [
      {
        title: "Taekwon-Do",
        desc: "Taekwondo is the art of kicking and striking with skill, control, and discipline.",
        image: require("../assets/service_card/service1.jpg")
      },
      {
        title: "Kickboxing MuayThai",
        desc: "Kickboxing and Muay Thai are dynamic combat sports focused on power, speed, and full-body conditioning.",
        image: require("../assets/service_card/service2.jpg")
      },
      {
        title: "Zumba Dance",
        desc: "Zumba is a high-energy dance fitness program that combines Latin music with fun workout moves.",
        image: require("../assets/service_card/service3.jpg")
      }
    ],

    programmes: {
      heading: "90+ High-Impact Classes Every Month",
      description:
        "Sweat. Strength. Skills. High-impact classes in fitness and martial arts designed to transform you.",
      programmeCards: [
        {
          id: 1,
          title: "Kids Programme",
          description: "Specially designed Taekwondo classes for kids aged 4 and above, helping them build discipline, focus, coordination, and confidence in a fun and structured environment.",
          image: require("../assets/programmee/tkd.png"),
          alt: "Kids Programme"
        },
        {
          id: 2,
          title: "Youths & Adults Programme",
          description: "Specially designed Kickboxing & Muay Thai classes for ages 14 and above, including working adults, helping participants build discipline, focus, strength, and confidence in a fun, safe, and structured environment.",
          image: require("../assets/programmee/kb.png"),
          alt: "Youths Programme"
        },
        {
          id: 3,
          title: "Ladies Programme",
          description: "Fun, high-energy Zumba classes designed exclusively for ladies, helping you stay active, build confidence, and enjoy a healthy lifestyle in a supportive and energizing environment.",
          image: require("../assets/programmee/zumba.jpg"),
          alt: "Ladies Programme"
        }
      ]
    },

    access: {
      title: "Your Fitness Access,\nAnytime",
      description: "Manage student payments, records, and class information easily with our organized digital database system.",
      features: [
        "Organized Student Database",
        "Attendance & Progress Records",
        "Invoice & Payment History",
        "Fast Member Information Access"
      ]
    },

    testimonial: {
      title: "Member's Testimonials",
      subtitle: "See what our members are saying about us.",
      buttonText: "Start Your Journey",
      items: [
        {
          id: 1,
          name: "Arun Kumar",
          description: "Joining this fitness program completely changed my lifestyle. The trainers are supportive, and the workout plans are easy to follow.",
          videoUrl: "https://www.youtube.com/embed/SKIsmLpYDKM",
          isVideo: true
        },
        {
          id: 2,
          name: "Vinothini",
          description: "Great training environment and supportive coaches. I’ve seen real progress in my fitness since joining.",
          videoUrl: "https://www.youtube.com/embed/QVljx77yJ_Y",
          isVideo: true
        }
      ]
    },

    marque: [
      {
        id: 1,
        image: require("../assets/marqee_img/fitness1.png")
      },
      {
        id: 2,
        image: require("../assets/marqee_img/2.jpeg")
      },
      {
        id: 3,
        image: require("../assets/marqee_img/3.jpeg")
      },
      {
        id: 4,
        image: require("../assets/marqee_img/fitness4.png")
      },
      {
        id: 5,
        image: require("../assets/marqee_img/fitness5.png")
      },
      {
        id: 6,
        image: require("../assets/marqee_img/1.jpeg")
      },
      {
        id: 7,
        image: require("../assets/marqee_img/4.jpeg")
      }
    ],
trialForm: {
  title: "Sign Up For Your Trial Class",
  subtitle: "We'll get in touch within 24 hours.",
  GymDetail: {         
    GYM_NAME: "V Studio",         
    ORG_WHATSAPP: "103712517"    
  },

      fields: [
        {
          name: "firstName",
          label: "First Name",
          type: "text",
          placeholder: "Enter First Name"
        },
        {
          name: "lastName",
          label: "Last Name",
          type: "text",
          placeholder: "Enter Last Name"
        },
        {
          name: "mobile",
          label: "Mobile Number",
          type: "text",
          placeholder: "Enter Mobile Number"
        },
        {
          name: "gender",
          label: "Gender",
          type: "select",
          options: [
            { label: "Male", value: "male" },
            { label: "Female", value: "female" }
          ]
        },
        {
          name: "preferredClass",
          label: "Preferred Classes",
          type: "select",
          options: [
            { label: "Taekwon-Do", value: "taekwondo" },
            { label: "Kickboxing MuayThai", value: "Kickboxing MuayThai" },
            { label: "Zumba", value: "Zumba" }
          ]
        }
      ]
    }
  };
}

